// extracted by mini-css-extract-plugin
export default {"HomeVideo":"HomeVideo_HomeVideo__1JC2m","iframe":"HomeVideo_iframe__HHwKw"};